import { PathogenTypeEnum } from "@agent/domain/models/agent.model";
import type { CheckboxOption } from "@core/domain/types/checkbox-option";
import { injectable } from "inversify";

@injectable()
export class AgentInMemoryDatasource {
    fetchAllPathogenTypes(): CheckboxOption<PathogenTypeEnum>[] {
        return [
            {
                label: "fungi",
                value: PathogenTypeEnum.HONGO,
            },
            {
                label: "virus",
                value: PathogenTypeEnum.VIRUS,
            },
            {
                label: "bacteria",
                value: PathogenTypeEnum.BACTERIA,
            },
            {
                label: "insect",
                value: PathogenTypeEnum.INSECTO,
            },
        ];
    }
}
